const header = $(".header");

function checkScroll() {
  if ($(window).scrollTop() >= 1) {
    header.addClass("header--sticky");
  } else {
    header.removeClass("header--sticky");
  }
}

jQuery(document).ready(() => {
  checkScroll();
  $(window).scroll(function() {
    checkScroll();
  });

  $(
    ".header__desktop .header__menu > .menu-item:not(.menu-item-has-children)"
  ).hover(function() {
    $(this).toggleClass("menu-item-active");
  });

  const menuParent = $(".header__menu .menu-item-has-children");

  $(".header__desktop .header__menu > .menu-item")
    .mouseenter(function() {
      const currentLi = $(this);
      header.addClass("header--white");
      if (currentLi.hasClass("menu-item-has-children")) {
        currentLi.siblings().each(function() {
          if ($(this).hasClass("submenu-opened")) {
            $(this).removeClass("submenu-opened");
          } else {
            currentLi.addClass("submenu-opened");
          }
        });
      } else {
        currentLi.siblings().removeClass("submenu-opened");

        $("body").removeClass("darken");
      }
    })
    .mouseleave(function() {
      if (menuParent.hasClass("submenu-opened") === false) {
        header.removeClass("header--white");
      }
    });

  $(".underlayer").mouseenter(function() {
    if (menuParent.hasClass("submenu-opened")) {
      header.removeClass("header--white");
      menuParent.removeClass("submenu-opened");
      $("body").removeClass("darken");
    }
  });

  menuParent.mouseenter(function() {
    $("body").addClass("darken");
  });

  $(".mobile-menu .menu-item-has-children > a").on("click", function(e) {
    if (
      $(this)
        .closest(".menu-item")
        .children("ul")
        .is(":visible") !== true
    ) {
      $(this)
        .closest(".menu-item")
        .addClass("js-active");
      e.preventDefault();
      return false;
    } else {
      $(this)
        .closest(".menu-item")
        .removeClass("js-active");
      e.preventDefault();
      return false;
    }
  });

  const menuBtn = $("#mobile-menu-btn");

  menuBtn.on("click", function() {
    $(this).toggleClass("menu-btn--clicked");
    $("html").toggleClass("nav-opened");
  });
});



// WEBPACK FOOTER //
// ./scripts/modules/layouts-functions/header.js